// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "styles/" + chunkId + ".main-" + {"68":"406d44","217":"f2e967","896":"7aee25"}[chunkId] + ".css";
};